import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';
import { ETicketEmdSelectSubHeaderComponent } from './e-ticket-emd-select-sub-header.component';

@NgModule({
  declarations: [ETicketEmdSelectSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [ETicketEmdSelectSubHeaderComponent],
})
export class ETicketEmdSelectSubHeaderModule {}
